import React from "react";
import { Reveal } from "../shared/Reveal";

const EVERY_BG =
  "linear-gradient(180deg,rgba(11,21,51,.30),rgba(11,21,51,.70) 68%,#0B1533),url('/brand/every_building.jpg')";

export default function EveryBuilding() {
  return (
    <section id="every-building" className="everybuilding" style={{ backgroundImage: EVERY_BG }}>
      <div className="wrap">
        <Reveal className="ebkick" tag="div">A NEW ERA FOR BUILDINGS</Reveal>
        <Reveal className="ebtitle" tag="h2">Every Building Will <span className="g">Think for Itself.</span></Reveal>
        <Reveal className="ebbody" tag="p">Through our global partnerships with <b>state-of-the-art technology</b> and over <span className="g">20 years of R&amp;D</span> — active in more than <span className="g">70 countries</span> and trusted by globally recognised brands.</Reveal>
      </div>
    </section>
  );
}
